<template>
	<view class="container bgf">
	  <!-- <view class="top-bar">
			
	  </view> -->
	 <view class="top-bar-pad" style="padding: 10rpx;">
		<block v-for="(item, index) in selParams" :key="index">
		  <text>{{item.name}}</text><text v-if="index != level" class="gray" style="margin:0 3px">></text>
		</block>  
	  </view>
	  <block v-if="modelType != '' && models.length < 1">
	    <view class="nodata">找不到相关的数据</view>
	  </block>
	  
	  <block v-else>
	    <view class="list-view model-list">
			<!--生产商车系 begin-->
			<block v-if="modelType == 'mod1'">
				<block v-for="(model, index) in models" :key="index">
					<view class="list-group">{{model.make_name}}</view>
					<uni-list>
						<navigator v-for="mod1 in model.mods" :key="mod1.mod1_id" :url="nextUrl+'&mod1_id='+mod1.mod1_id">
							<uni-list-item>{{mod1.mod1_name}}</uni-list-item>
						</navigator>
					</uni-list>
				</block>
			</block>
			
			<!--二级车型-->
			<block v-if="modelType == 'mod2'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&mod2_id='+model.mod2_id">
						<uni-list-item>
							<view>{{model.mod2_name}}<text class="gray marl5">{{model.year}}</text></view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
			
			<!--排量 + 变速器 + 驱动-->
			<block v-if="modelType == 'cctrandrive'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&cctran='+model.val+'&mod3_drive_short='+model.mod3_drive_short">
						<uni-list-item>
							<view>{{model.cc}} {{model.mod3_drive_short}} {{model.tran}}</view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
	
			<!--排量 + 变速器-->
			<block v-if="modelType == 'cctran'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&cctran='+model.val">
						<uni-list-item>
							<view>{{model.cc}} {{model.tran}}</view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
			
			<!--排量-->
			<block v-if="modelType == 'cc'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&mod3_cc_name='+model.mod3_cc_name">
						<uni-list-item>
							<view>{{model.mod3_cc_name}}</view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
			
			<!--驱动-->
			<block v-if="modelType == 'drive'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&mod3_drive_short='+model.mod3_drive_short">
						<uni-list-item>
							<view>{{model.mod3_drive_short}}</view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
			
			<!--发动机-->
			<block v-if="modelType == 'engine'">
				<uni-list>
					<navigator v-for="(model, index) in models" :key="index" :url="nextUrl+'&mod3_cc='+model.mod3_cc+'&mod3_kw='+model.mod3_kw+'&mod3_engine='+model.mod3_engine">
						<uni-list-item>
							<view>
							  <text class="marr10">{{model.mod3_engine}}</text>
							  <text class="marr10">{{model.mod3_kw}}kw</text>
							  <text class="marr10">{{model.mod3_cc}}cc</text>
							</view>
						</uni-list-item>
					</navigator>
				</uni-list>
			</block>
			
			<!--车型明细-->
			<block v-if="modelType == 'mod3'">
				<uni-list>
					<view v-for="(model, index) in models" :key="index" @click="gotoPage(model)">
						<uni-list-item>
							<view class="mod3-item">{{model.mod2_name}} {{model.mod3_name}} <text class="gray marl5">{{model.year}}</text></view>
							<view class="mod3-info">
								<text class="marr10" v-if="model.mod3_engine != ''">{{model.mod3_engine}}</text>
								<text class="marr10" v-if="model.mod3_kw != ''">{{model.mod3_kw}}kw</text>
								<text class="marr10" v-if="model.mod3_cc != ''">{{model.mod3_cc}}cc</text>
								<text class="marr10" v-if="model.mod3_transmission != ''">{{model.mod3_transmission}}</text>
								<text class="marr10" v-if="model.mod3_drive != ''">{{model.mod3_drive}}</text>
								<text class="marr10" v-if="model.mod3_fuel != ''">{{model.mod3_fuel}}</text>
							</view>
						</uni-list-item>
					</view>
				</uni-list>
			</block>
	    </view>
	  </block>
	</view>
</template>

<script>
	import uniList from "@/components/uni-list/uni-list.vue"
	import uniListItem from "@/components/uni-list-item/uni-list-item.vue"
	const app = getApp();
	export default {
		components: {uniList,uniListItem},
		data() {
			return {
				level:'L0', 
				models:[],
				modelType: '',
				nextUrl: '/pages/model/model',
				selParams:{}
			}
		},
		onLoad: function (option) {
		    var that = this;
		    that.level = option.level;
		    app.getApi('GET', 'gzh/getGzhModels', option, 1, function (data) {
				if (data.dtype == 'mod2'){
					for (var i in data.data){
					  data.data[i].year = app.formatYear(data.data[i].mod2_start_year, data.data[i].mod2_end_year);
					}
				}
				if (data.dtype == 'mod3') {
					for (var i in data.data) {
					  data.data[i].year = app.formatYear(data.data[i].mod3_start_year, data.data[i].mod3_end_year);
					}
				}
				var lastUrlParam = option;
				lastUrlParam.level = data.next;
				var temp = new Array();
				for (var i in lastUrlParam) {
					if (lastUrlParam[i] != '')  temp.push(i + '=' + lastUrlParam[i]);
				}
				var newUrlParam = temp.join('&');
				that.models = data.data;
				that.modelType = data.dtype;
				that.nextUrl = data.next == 'item' ? '/pages/item/search?type=model' : '/pages/model/model?' + newUrlParam;
		     
		    });
			console.log(option);
		    app.getApi('GET', 'gzh/getGzhModelsParams', option, 1, function (data) {
				that.selParams = data;
		    });
		},
		methods: {
			gotoPage(model){
				// :url="nextUrl+'&mod3_id='+model.mod3_id+'&name='+model.mod2_name+model.mod3_name"	
				let that = this;
				let l3Param = that.selParams.L3.param;
				var temp = new Array();
				for (var i in l3Param) {
					if (l3Param[i] != '')  temp.push(i + '=' + l3Param[i]);
				}
				var newUrlParam = temp.join('&');
				var brandMake = model.make_show_brand && model.make_show_brand == 1? model.brand_name+' ': model.make_name+' ';
				var name = brandMake + model.mod2_name+model.mod3_name
				let url = that.nextUrl+'&'+newUrlParam+'&mod3_id='+model.mod3_id+'&name='+name;
				uni.navigateTo({
					url:url
				})
			}
		}
	}
</script>

<style>

</style>
